import { resendVerificationEmail, verifyOtp } from "api";
import Button from "components/global/Button";
import Spacer from "components/global/Spacer";
import WarningIconTriangle from "icons/WarningIconTriangle";
import { connect } from "react-redux";
import { showAlert } from "utils/utils";
import { BannerWrapper } from "views/socialMedia/ManageChannelsStyles";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import VerifyOtpModal from "./VerifyOtpModal";

const VerifyEmailBanner = ({ user }) => {
  const [showModal, setShowModal] = useState(false);

  const { mutate: sendVerificationCode, isPending } = useMutation({
    mutationFn: () => resendVerificationEmail({ email: user.email }),
    onSuccess: () => {
      setShowModal(true);
    },
    onError: (error) => {
      showAlert({
        msg: error.message ?? "An error occurred",
        type: "danger",
      });
    },
  });

  if (user.email_verified_at) {
    return null;
  }

  return (
    <>
      <BannerWrapper
        bg="#FFFAE5"
        contentColor="#07070C"
        className="flexRow alignCenter justifySpaceBetween"
      >
        <div className="flexRow alignCenter">
          <WarningIconTriangle color={"#07070C"} size="20px" />
          <Spacer x={2} />
          <div className="content">
            <p className="semiBold">Verify email address</p>
            <p className="l3 colorGrey6">
              Please verify your email address to unlock full access to
              Postpaddy.
            </p>
          </div>
        </div>

        <Button
          text="Verify email"
          className="borderedGrey l3 semiBold"
          height="40px"
          onClick={sendVerificationCode}
          loading={isPending}
        />
      </BannerWrapper>

      {showModal && <VerifyOtpModal user={user} setShowModal={setShowModal} />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(VerifyEmailBanner);
